import { Injectable, inject } from '@angular/core';
import { BaseApiService } from '@bo/ng-api';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { DetailResponse, UpdateData, ValidateData, ValidResponse, VerifyData } from '../../_interfaces/verify-account';

@Injectable({
  providedIn: 'root',
})
export class VerifyService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_VERIFY_PHONE: string = 'verify/phone';
  URL_VERIFY_EMAIL: string = 'verify/email';
  URL_UPDATE_CONTACT_DETAILS: string = 'user/contact-change';
  URL_UPDATE_CONTACT_DETAILS_SEND: string = 'send';
  URL_UPDATE_CONTACT_DETAILS_VALID: string = 'valid';
  URL_UPDATE_CONTACT_DETAILS_VERIFY: string = 'verify';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  /**
   * Verify updated email address.
   * @param id
   * @param data
   * @return Observable<DetailResponse>
   */
  verifyEmail(id: string, data: VerifyData): Observable<DetailResponse> {
    const url = this.getUrl([this.URL_VERIFY_EMAIL, id], true);
    return this.http.post<DetailResponse>(url, data);
  }

  /**
   * Verify updated phone number.
   * @param id
   * @param data
   * @return Observable<DetailResponse>
   */
  verifyPhone(id: string, data: VerifyData): Observable<DetailResponse> {
    const url = this.getUrl([this.URL_VERIFY_PHONE, id], true);
    return this.http.post<DetailResponse>(url, data);
  }

  /**
   * Send OTP for contact details verification.
   * @param id Contact Details Change ID
   * @return Observable<DetailResponse>
   */
  sendContactDetailsOTP(id: string): Observable<DetailResponse> {
    const url = this.getUrl([this.URL_UPDATE_CONTACT_DETAILS, id, this.URL_UPDATE_CONTACT_DETAILS_SEND], true);
    return this.http.post<DetailResponse>(url, {});
  }

  /**
   * Validate contact details token.
   * @param id Contact Details Change ID
   * @param data
   * @return Observable<ValidResponse>
   */
  validContactDetailsToken(id: string, data: ValidateData): Observable<ValidResponse> {
    const url = this.getUrl([this.URL_UPDATE_CONTACT_DETAILS, id, this.URL_UPDATE_CONTACT_DETAILS_VALID], true);
    return this.http.post<ValidResponse>(url, data);
  }

  /**
   * Update contact details.
   * @param id Contact Details Change ID
   * @param data
   * @return Observable<DetailResponse>
   */
  verifyContactDetails(id: string, data: UpdateData): Observable<DetailResponse> {
    const url = this.getUrl([this.URL_UPDATE_CONTACT_DETAILS, id, this.URL_UPDATE_CONTACT_DETAILS_VERIFY], true);
    return this.http.put<DetailResponse>(url, data);
  }
}
